import React from "react";

export default ({children}) => {
    return (<div className="flex mb-4 justify-between">
        {children}
    </div>)
}